module.exports = __webpack_public_path__ + "img/home-hero_en-3.8233a07.png";